import React from 'react';
import PropTypes from 'prop-types';
import Loading from './Loading';
import Error from './Error';
import NotFound from './NotFound';
var PseudoStates = function PseudoStates(_ref) {
  var status = _ref.status,
    isLoading = _ref.isLoading,
    error = _ref.error,
    data = _ref.data;
  var isLoad = isLoading || status === 'loading';
  var isErr = error || status === 'error';
  var isNotFound = !data && !isLoad && !isErr;
  return React.createElement(React.Fragment, null, isLoad && React.createElement(Loading, null), isErr && React.createElement(Error, null), isNotFound && React.createElement(NotFound, null));
};
PseudoStates.propTypes = {
  status: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  data: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};
PseudoStates.defaultProps = {
  status: undefined,
  isLoading: false,
  error: undefined,
  data: undefined
};
export default PseudoStates;